import { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

import { ActionFields, actionGQLFields } from '../common/action.fields.js'
import { SpaceFields, spaceGQLFields } from '../space/space.fields.js'

import {
  LocaleGroupFields,
  localeGroupGQLFields,
} from './localeGroup.fields.js'

export function getLocaleGroupGQLQuery(
  fields: LocaleGroupFields,
): DocumentNode {
  return gql`
    query GetLocaleGroup($id: ID!) {
      localeGroup(id: $id) {
        ${localeGroupGQLFields(fields)}
      }
    }
  `
}

export function getLocaleGroupsGQLQuery(
  fields: LocaleGroupFields,
): DocumentNode {
  return gql`
    query GetLocaleGroups {
      localeGroups {
        ${localeGroupGQLFields(fields)}
      }
    }
  `
}

export function getSpaceByLocaleGQLQuery(fields: SpaceFields): DocumentNode {
  return gql`
    query SpaceByLocale($localeGroupId: ID!, $locale: String!) {
      spaceByLocale(localeGroupId: $localeGroupId, locale: $locale) {
        ${spaceGQLFields(fields)}
      }
    }
  `
}

export function createLocaleGroupGQLMutation(
  fields: LocaleGroupFields,
): DocumentNode {
  return gql`
    mutation CreateLocaleGroup($input: CreateLocaleGroupInput!) {
      createLocaleGroup(input: $input) {
        ${localeGroupGQLFields(fields)}
      }
    }
  `
}

export function updateLocaleGroupGQLMutation(
  fields: ActionFields,
): DocumentNode {
  return gql`
    mutation UpdateLocaleGroup($id: ID!, $input: UpdateLocaleGroupInput!) {
      updateLocaleGroup(id: $id, input: $input) {
        ${actionGQLFields(fields)}
      }
    }
  `
}

export function deleteLocaleGroupGQLMutation(
  fields: ActionFields,
): DocumentNode {
  return gql`
    mutation DeleteLocaleGroup($id: ID!) {
      deleteLocaleGroup(id: $id) {
        ${actionGQLFields(fields)}
      }
    }
  `
}

export function createLocaleSpaceGQLMutation(
  fields: SpaceFields,
): DocumentNode {
  return gql`
    mutation CreateLocaleSpace(
      $localeGroupId: ID!
      $input: CreateLocaleSpaceInput!
    ) {
      createLocaleSpace(localeGroupId: $localeGroupId, input: $input) {
        ${spaceGQLFields(fields)}
      }
    }
  `
}

export function removeSpaceFromLocaleGroupGQLMutation(
  fields: ActionFields,
): DocumentNode {
  return gql`
    mutation RemoveSpaceFromLocaleGroup($localeGroupId: ID!, $spaceId: ID!) {
      removeSpaceFromLocaleGroup(
        localeGroupId: $localeGroupId
        spaceId: $spaceId
      ) {
        ${actionGQLFields(fields)}
      }
    }
  `
}
